<hr>
<h1><p>Logout complete, you will be brought to the home page.</p></h1>
<hr>